import DiscoveryFooter from '@ui/Footer/DiscoveryFooter/component'

export default () => {
  const footerEl = document.querySelector('.c-discovery-footer') as HTMLElement

  if (!footerEl) {
    return
  }

  DiscoveryFooter(footerEl)
}
